module.exports = __webpack_public_path__ + "static/Carpool-redesign-1-07ed19f58d0314b341262c8f9f01b1af.gif";